module.exports = __webpack_public_path__ + "static/media/iconCanvas02.e267559f.svg";